import { render, staticRenderFns } from "./CompanyDetailsFeatures.vue?vue&type=template&id=f7a025dc&"
import script from "./CompanyDetailsFeatures.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports